<template>
  <div class="container-fluid">
    <div class="row justify-content-between my-3">
      <div class="col"><h4>Хот аймаг</h4></div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-success"
          data-toggle="modal"
          data-target="#schoolModal"
        >
          Хот аймаг нэмэх
        </button>
      </div>
    </div>
    <div>
      <add-bulk :path="'cities/'"></add-bulk>
    </div>
    <div v-if="cities != null && cities.length > 0">
      <table class="table table-bordered">
        <tr v-for="(q, index) in cities" v-bind:key="q.id">
          <td>{{ index + 1 }}.</td>
          <td>{{ q.name }}</td>
          <td>
            <button
              @click="_goDetail(q.id)"
              class="btn btn-sm btn-outline-secondary mr-2"
              style="border-color: #d1d3e2 !important"
            >
              сум дүүрэг+
            </button>
            <button @click="_editSchool(q)" class="btn btn-sm btn-warning">
              засах
            </button>
          </td>
        </tr>
      </table>
    </div>

    <hr />
    <template v-if="cities != null && cities.length > 0">
      <p v-for="(city, cindex) in cities" :key="cindex">
        { name: '{{ city.name }}',  
        <template v-if="city.districts">
            sumuud: [
          <small v-for="(district, dindex) in city.districts" :key="dindex">
            '{{ district.name }}' ,
          </small>
           ] },
        </template>
      </p>
    </template>
    <!-- Modal -->
    <div
      class="modal fade"
      id="schoolModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="schoolModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="schoolModalLabel">Хот аймаг нэмэх</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <input
                  v-model.trim="object.name"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Бүрэлдэxүүн сургуулийн нэр"
                />
              </div>
              <div class="form-group">
                <input
                  v-model.trim="object.shortName"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Бүрэлдэxүүн сургуулийн товчилсон нэр"
                />
              </div>
              <div class="form-group">
                <textarea
                  rows="10"
                  v-model.trim="object.description"
                  class="form-control"
                  id="exampleInputPassword"
                  placeholder="Тайлбар мэдээлэл"
                />
              </div>

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Цуцлаx
            </button>
            <button
              @click="saveSchool"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >
              Xадгалаx
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");
import AddBulk from "./AddBulk";

export default {
  components: {
    AddBulk,
  },
  data() {
    return {
      cities: [],
      departments: [],
      object: {
        name: "",
        shortName: "",
        description: "",
      },
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  methods: {
    _getQA() {
      fb.db
        .collection("cities")
        .orderBy("index")
        .onSnapshot((querySnapshot) => {
          this.cities = [];
          querySnapshot.forEach((doc) => {
            let object = doc.data();
            object.id = doc.id;

            doc.ref
              .collection("districts")
              .get()
              .then((districts) => {
                object.districts = [];
                districts.forEach((ddoc) => {
                  console.log(ddoc.data());
                  let dist = ddoc.data();
                  dist.id = ddoc.id;
                  object.districts.push(dist);
                });
                //console.log(distDoc.data())
                // let dist = distDoc.data()
                // dist.id = distDoc.id
                // object.districts.push(dist)
              });
            this.cities.push(object);
          });
        });
    },
    _goQuestions(postId) {
      this.$router.push({ name: "Questions", params: { qaId: postId } });
    },
    _goDetail(schoolId) {
      this.$router.push({ name: "CityDetail", params: { schoolId: schoolId } });
    },
    saveSchool() {
      if (
        this.object != null &&
        this.object != null &&
        this.object.name != ""
      ) {
        if (this.object.id != null && this.object.id != "") {
          fb.db
            .collection("cities")
            .doc(this.object.id)
            .update({
              name: this.object.name,
              shortName: this.object.shortName,
              description: this.object.description,
              modifiedAt: new Date(),
              modifiedUser: fb.usersCollection.doc(
                this.$store.getters.currentUser.uid
              ),
            });
        } else {
          this.object.createdAt = new Date();
          this.object.userId = this.$store.getters.currentUser.uid;
          this.object.user = fb.usersCollection.doc(
            this.$store.getters.currentUser.uid
          );
          fb.db.collection("cities").doc(this.object.name).set(this.object);
        }
        this.object = {
          name: null,
          shortName: null,
          description: null,
        };
      } else {
        alert("Та сургуулийн нэр, тайлбараа оруулна уу");
      }
    },
    _editSchool(school) {
      this.object = Object.assign({}, school);
      $("#schoolModal").modal("toggle");
    },
    _deleteSchool(school) {
      var result = confirm("Та " + school.name + " сургуулийг устгах уу?");
      if (result) {
        fb.db.collection("cities").doc(school.id).delete();
      }
    },
  },
  created() {
    var _this = this;

    this._getQA();
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>
